import { Component, OnInit, } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RouterPathService } from "../../../core/common/variables/router-path.service";
import { TranslateService } from "../../common/variables/translate-service";

@Component({
  selector: 'sen-app-inverter-plan',
  templateUrl: './inverter-plan.component.html',
  styleUrls: ['./inverter-plan.component.scss']
})
export class InverterPlanComponent implements OnInit {
  inverterTabLink: any[];
  activeLink: String;
  routerurL: string;
  routerEventUnSubscribe: Subscription;

  constructor(private router: Router, private routerPath: RouterPathService, public translate: TranslateService) {
    this.inverterTabLink = [
      { label: `${this.translate.getLng('SEARCH')} ${this.translate.getLng('INVERTER')}`, link: this.routerPath.IPSearchInverterString },
      { label: this.translate.getLng('INVERTER_CUSTOMIZE'), link: this.routerPath.IPCustomizeString },
      { label: this.translate.getLng('INVERTER_STRINGING'), link: this.routerPath.IPStringingString },
      { label: this.translate.getLng('INVERTER_AC_DC'), link: this.routerPath.IPAcdcString },
    ];

    this.activeLink = this.inverterTabLink[0].link;

    this.routerEventUnSubscribe = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.inverterTabLink.forEach(item => {
          if (event.url.includes(item.link)) {
            this.activeLink = item.link;
          }
        })
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.routerEventUnSubscribe.unsubscribe();
  }
}
